import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DeactivateSchoolDialogData {
  schoolName: string;
}

/**
 * The typed confirmation: the school's own name, ignoring case and runs of whitespace, non-breaking
 * spaces included. The backend applies the same rule (StringUtils.normalizeSpace + equalsIgnoreCase).
 */
export function schoolNameMatches(schoolName: string | null | undefined, typedName: string | null | undefined): boolean {
  const expected = normaliseName(schoolName);
  return expected.length > 0 && expected === normaliseName(typedName);
}

function normaliseName(name: string | null | undefined): string {
  return (name || '').replace(/[\s\u00A0]+/g, ' ').trim().toLowerCase();
}

/**
 * Asks a school admin to confirm that the school leaves LOQT (DIGI-1855). There is no way back, so
 * the admin types the school name and the confirm button stays disabled until it matches. Closes
 * with the typed name, or with nothing on cancel.
 */
@Component({
  selector: 'app-deactivate-school-dialog',
  templateUrl: './deactivate-school-dialog.component.html',
  styleUrl: './deactivate-school-dialog.component.scss',
  standalone: false,
})
export class DeactivateSchoolDialogComponent {
  typedName = '';

  constructor(
    public dialogRef: MatDialogRef<DeactivateSchoolDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: DeactivateSchoolDialogData
  ) {}

  get nameMatches(): boolean {
    return schoolNameMatches(this.data?.schoolName, this.typedName);
  }

  confirm(): void {
    if (!this.nameMatches) {
      return;
    }
    this.dialogRef.close(this.typedName.trim());
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
